<template>
  <div v-if="visible" class="blik-help-modal" @click.self="close">
    <div class="blik-help-modal__dialog" role="dialog" aria-modal="true" @click.stop>
      <div class="blik-help-modal__header">
        <img :src="logo" alt="BLIK" class="blik-help-modal__logo" />

        <button
          type="button"
          class="blik-help-modal__close"
          :aria-label="$t('blik_invoice__help_link')"
          @click="close">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
            <path
              d="M13.6193 15.4547L-2.19643e-05 1.83534L1.83521 0.000111341L15.4545 13.6194L13.6193 15.4547ZM1.83521 15.4547L-2.19643e-05 13.6194L13.6193 0.000111341L15.4545 1.83534L1.83521 15.4547Z"
              fill="currentColor" />
          </svg>
        </button>
      </div>

      <h2 class="blik-help-modal__title">{{ $t('blik_invoice__help_link') }}</h2>
      <p class="blik-help-modal__text">{{ $t('blik_invoice__help_text') }}</p>

      <div class="blik-help-modal__banks">
        <img
          v-for="(bank, index) in bankApps"
          :key="index"
          class="blik-help-modal__bank"
          :src="bank"
          alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelpModal',

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    logo: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      bankApps: [],
      bankAppsLoading: false,
    };
  },

  watch: {
    visible: {
      immediate: true,
      handler(isOpen) {
        if (isOpen) {
          document.addEventListener('keydown', this.onKeydown);
          this.loadBankApps();
        } else {
          document.removeEventListener('keydown', this.onKeydown);
        }
      },
    },
  },

  beforeDestroy() {
    document.removeEventListener('keydown', this.onKeydown);
  },

  methods: {
    close() {
      this.$emit('close');
    },

    async loadBankApps() {
      if (this.bankApps.length || this.bankAppsLoading) {
        return;
      }

      this.bankAppsLoading = true;
      try {
        const { default: bankApps } = await import('../assets/bank-app');
        this.bankApps = bankApps;
      } finally {
        this.bankAppsLoading = false;
      }
    },

    onKeydown(event) {
      if (event.key === 'Escape') {
        this.close();
      }
    },
  },
};
</script>

<style lang="scss">
.blik-help-modal {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
  background: rgba(15, 15, 17, 0.62);

  &__dialog {
    width: 100%;
    max-width: 760px;
    padding: 34px 40px;
    background: #ffffff;
    border-radius: 18px;
    box-shadow: 0px 22px 65px 0px #14182038;
    text-align: left;
    font-family: 'Segoe UI', Inter;
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 28px;
  }

  &__logo {
    display: block;
    height: 42px;
    width: auto;
  }

  &__close {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    border: 0;
    background: transparent;
    color: #161616;
    cursor: pointer;
  }

  &__title {
    margin: 0 0 16px;
    font-size: 29px;
    line-height: 34px;
    color: #161616;
  }

  &__text {
    margin: 0 0 24px;
    font-size: 17px;
    line-height: 26px;
    color: #5b5b61;
  }

  &__banks {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  &__bank {
    display: block;
    flex: 1 1 66px;
    min-width: 66px;
    max-width: 76px;
    height: 66px;
    border-radius: 10px;
    object-fit: fill;
  }

  @media (max-width: 570px) {
    align-items: flex-end;
    padding: 0;

    &__dialog {
      max-width: none;
      padding: 22px 18px 22px;
      border-radius: 24px 24px 0 0;
    }

    &__header {
      margin-bottom: 20px;
    }

    &__logo {
      height: 36px;
    }

    &__title {
      font-size: 23px;
      line-height: 28px;
      margin-bottom: 12px;
    }

    &__text {
      font-size: 15px;
      line-height: 22px;
      margin-bottom: 20px;
    }
  }
}

html[data-color-scheme='dark'] {
  .blik-help-modal {
    background: rgba(0, 0, 0, 0.45);

    &__dialog {
      background: #3a3a3d;
      box-shadow: 0 18px 44px rgba(0, 0, 0, 0.32);
    }

    &__close,
    &__title {
      color: #ffffff;
    }

    &__text {
      color: #e0e0e0;
    }
  }
}
</style>
